var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},[_c('div',{staticClass:"dropdown-button",on:{"click":_vm.toggle}},[_vm._t("button")],2),_c('div',{ref:"content",staticClass:"dropdown-content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }